import type { FaireProductEntity } from "../../entity_types/product";

export const p_8q8ejhuqfy: FaireProductEntity = {
  token: "p_8q8ejhuqfy",
  type: "product",
  name: "Peony Albion x Geometry",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/ebf2bbb67fe8113968b45dd97cf73bff67c9c48028fc2481af9828adcca5390d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43e72a6f59585ee47335d0ba388a81a0dc472321dd2f74c226dfc3b83e9e2f9e.jpeg",
    "https://cdn.faire.com/fastly/76e84ca09b5fa860512a8b8f07b00c4838b7be1d914adb6e5d8c6d973d61281b.jpeg",
    "https://cdn.faire.com/fastly/4ca5df42f66399af0f9ad901a7388f230012ff40d72420fccc1d5fc59d223971.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\n♺ Made from post-consumer recycled materials\n\n\n\n27”x72”\n\nDesigned in California\n\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n... \n\nFinally, a yoga towel designed to keep your feet — and your practice — grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n * 27”x72”\n\n * Ultra absorbent and fast-drying\n\n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop \n * Machine washable ",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:00:03.173Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
